const US = {
    moduleTitle: 'Download Center',
    appTitle: 'Explore the EcoFlow App',
    appDesc: 'Download the EcoFlow App. Monitor and control your power usage, and set limits and modes.',
    otherTitle: 'Documentation and Manuals',
    otherDesc: 'Learn more about EcoFlow products with user manuals, video tutorials and other official documentation.',
};

export const C_DATA: {
    [key: string]: {
        moduleTitle: string;
        appTitle: string;
        appDesc: string;
        otherTitle: string;
        otherDesc: string;
    };
} = {
    cn: {
        moduleTitle: '下载中心',
        appTitle: '探索 EcoFlow APP',
        appDesc: '立即下载正浩EcoFlow App。全面监测并控制您的用电状态、参数和模式。',
        otherTitle: '文档与手册',
        otherDesc: '获取使用说明、视频教程等官方文档，帮助您全面了解 EcoFlow 产品',
    },
    us: US,
    za: US,
    ca: US,
    eu: US,
    uk: US,
    au: US,
    de: {
        moduleTitle: 'Download-Center',
        appTitle: 'Entdecken Sie die EcoFlow App',
        appDesc: 'Laden Sie die EcoFlow App herunter. Überwachen und steuern Sie Ihren Energieverbrauch, Ihre Parameter und Modi.',
        otherTitle: 'Dokumentation und Handbücher',
        otherDesc: 'Erfahren Sie mehr über EcoFlow Produkte in Benutzerhandbüchern, Video-Tutorials und anderen offiziellen Dokumenten.',
    },
    fr: {
        moduleTitle: 'Centre de téléchargement',
        appTitle: "Découvrez l'application EcoFlow",
        appDesc: "Téléchargez l'application EcoFlow. Surveillez et gérez votre consommation d'énergie, vos paramètres et vos modes.",
        otherTitle: 'Documentation et manuels',
        otherDesc: "Apprenez-en davantage sur les produits EcoFlow grâce aux manuels d'utilisation, aux tutoriels vidéo et à d'autres documents officiels.",
    },
    it: {
        moduleTitle: 'Centro di download',
        appTitle: 'Esplora l’app EcoFlow',
        appDesc: 'Scarica l’app EcoFlow. Tieni sotto controllo e gestisci i tuoi consumi energetici e i parametri e le modalità di alimentazione.',
        otherTitle: 'Documentazione e manuali',
        otherDesc: 'Scopri di più sui prodotti EcoFlow grazie a manuali d’uso, video tutorial e altri documenti ufficiali.',
    },
    es: {
        moduleTitle: 'Centro de descargas',
        appTitle: 'Explora la aplicación EcoFlow',
        appDesc: 'Descarga la aplicación EcoFlow. Supervisa y controla tu consumo de energía, parámetros y modos.',
        otherTitle: 'Documentación y manuales',
        otherDesc: 'Conoce más sobre los productos EcoFlow a través de manuales de usuario, videotutoriales y otra documentación oficial.',
    },
    jp: {
        moduleTitle: 'ダウンロードセンター',
        appTitle: 'EcoFlow アプリを見る',
        appDesc: 'EcoFlow アプリをダウンロードします。電力使用量、パラメーター、モードを監視および制御します。',
        otherTitle: 'ドキュメントおよびマニュアル',
        otherDesc: 'ユーザーマニュアル、ビデオチュートリアル、その他の公式ドキュメントで EcoFlow 製品の詳細をご覧ください。',
    },
    kr: {
        moduleTitle: '다운로드 센터',
        appTitle: 'EcoFlow 앱 살펴보기',
        appDesc: 'EcoFlow 앱을 다운로드하세요. 전력 사용량, 매개변수 및 모드를 모니터링하고 제어합니다.',
        otherTitle: '문서 및 설명서',
        otherDesc: '사용 설명서, 비디오 튜토리얼 및 기타 공식 문서를 통해 EcoFlow 제품에 대해 자세히 알아보세요.',
    },
    sa: {
        moduleTitle: 'مركز التنزيل',
        appTitle: 'استكشف تطبيق EcoFlow',
        appDesc: 'تنزيل تطبيق EcoFlow. راقب استخدام الطاقة ومعلماتها وأوضاعها وتحكم في استخدامها.',
        otherTitle: 'الوثائق والأدلة الإرشادية',
        otherDesc: 'تعرّف على المزيد حول منتجات EcoFlow من خلال الأدلة الإرشادية، ومقاطع الفيديو التعليمية وغيرها من الوثائق الرسمية.',
    },
    tw: {
        moduleTitle: '下載中心',
        appTitle: '探尋 EcoFlow App',
        appDesc: '下載 EcoFlow App。監控您的用電量、參數與模式。',
        otherTitle: '文件與使用手冊',
        otherDesc: '借助用戶使用手冊、教學影片和其他正式文件了解 EcoFlow 產品詳細資訊。',
    },
    br: {
        moduleTitle: 'Central de download',
        appTitle: 'Explore o App EcoFlow',
        appDesc: 'Baixe o App EcoFlow. Monitore e controle o uso de energia, e defina limites e modos.',
        otherTitle: 'Documentação e manuais',
        otherDesc: 'Saiba mais sobre os produtos EcoFlow com manuais do usuário, tutoriais em vídeo e outras documentações oficiais.',
    },
    mx: {
        moduleTitle: 'Centro de descargas',
        appTitle: 'Explora la aplicación EcoFlow',
        appDesc: 'Descarga la aplicación EcoFlow. Supervisa y controla tu consumo de energía, parámetros y modos.',
        otherTitle: 'Documentación y manuales',
        otherDesc: 'Conoce más sobre los productos EcoFlow a través de manuales de usuario, videotutoriales y otra documentación oficial.',
    },
    ph: US,
};
